import { render, staticRenderFns } from "./WorkData.vue?vue&type=template&id=70606b7e&scoped=true&"
import script from "./WorkData.vue?vue&type=script&lang=js&"
export * from "./WorkData.vue?vue&type=script&lang=js&"
import style0 from "./WorkData.vue?vue&type=style&index=0&id=70606b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70606b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70606b7e')) {
      api.createRecord('70606b7e', component.options)
    } else {
      api.reload('70606b7e', component.options)
    }
    module.hot.accept("./WorkData.vue?vue&type=template&id=70606b7e&scoped=true&", function () {
      api.rerender('70606b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/WorkData.vue"
export default component.exports